import React from 'react';
import { TEST_IDS } from '@constants/testIds.ts';
import type { BasicAuthTab } from '@routes/sidebar/admin-center/tenant-client/___pages___/___shared___/create-edit-layout';
import { toDataCyValue } from '@utils/general.tsx';
import { isString } from 'lodash';

import { ActiveTab, InactiveTab, TabBarWrapper } from './styled.tsx';

interface Props {
    tabs: string[] | BasicAuthTab[];
    onTabClick: (tabIndex: number) => void;
    selectedTabIndex: number;
}

export const TabBar: React.FC<Props> = ({ tabs, onTabClick, selectedTabIndex }) => (
    <TabBarWrapper className="tab-bar">
        {tabs.map((tab, index) => {
            const tabName = isString(tab) ? tab : tab.name;

            return (
                <React.Fragment key={tabName}>
                    {index === selectedTabIndex ? (
                        <ActiveTab
                            className="tab-bar-active-tab"
                            data-cy={TEST_IDS.SHARED.adminTab(toDataCyValue(tabName))}
                            onClick={() => onTabClick(index)}
                        >
                            {tabName}
                        </ActiveTab>
                    ) : (
                        <InactiveTab
                            className="tab-bar-inactive-tab"
                            data-cy={TEST_IDS.SHARED.adminTab(toDataCyValue(tabName))}
                            onClick={() => onTabClick(index)}
                        >
                            {tabName}
                        </InactiveTab>
                    )}
                </React.Fragment>
            );
        })}
    </TabBarWrapper>
);
